import {
    ChevronDown,
    Search,
    CalendarDays,
    CircleHelp
} from "lucide-react";
import { useState } from "react";
import { Select, Input, Checkbox, DatePicker, Tooltip, Modal,Button } from "antd";
import dayjs from "dayjs";
import type { Dispatch, SetStateAction } from "react";

const { RangePicker } = DatePicker;

interface ExpenseDetail {
    status: number;
    step: number;
    history: { status: number }[];
}

interface ModalApproveProps {
    open: boolean;
    detail: ExpenseDetail;
    onClose: () => void;
    onApprove: () => void;
    onReject: () => void;
    //   setFilter: Dispatch<SetStateAction<Filter>>;
}


export function ModalApprove({ open, detail, onClose, onApprove, onReject }: ModalApproveProps) {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            title='Duyệt phiếu chi'
            footer={[
                <div className="flex gap-5 justify-end" style={{flexWrap: 'wrap'}}>
                     <Button
                         onClick={onApprove}
                        type="primary"
                        className="px-5 py-2.5 text-white font-medium rounded-md text-xs transition-colors"
                    >
                        DUYỆT
                    </Button>
                    <Button
                         onClick={onReject}
                        className="px-5 py-2.5 dark:text-white font-medium rounded-md text-xs transition-colors"
                        style={{background: 'transparent'}}
                    >
                        KHÔNG DUYỆT
                    </Button>
                   
                </div>
            ]}
        >
            <div className="space-y-5 pt-5">
                {/* Kho */}
                <div className="relative">
                    <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                        Tài khoản <span className="text-red-500">*</span>
                    </label>

                    <Input
                        placeholder="Tài khoản"
                        className="w-full h-10"
                        size="large"
                    />
                </div>

                {/* Từ ngày - Đến ngày */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div className="relative">
                        <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                            Ngày chi <span className="text-red-500">*</span>
                        </label>

                        <DatePicker
                            format="DD/MM/YYYY"
                            className="w-full"
                            size="large"
                        />
                    </div>

                    <div className="relative">
                        <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                            Ngày hạch toán <span className="text-red-500">*</span>
                        </label>

                        <DatePicker
                            format="DD/MM/YYYY"
                            className="w-full"
                            size="large"
                        />
                    </div>
                </div>

                 {/* Kho */}
                <div className="relative">
                    <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                        Ý kiến
                    </label>

                    <Input
                        placeholder="Thêm ý kiến hoặc để trống"
                        className="w-full h-10"
                        size="large"
                    />
                </div>
            </div>
        </Modal>

    )
}